// userSlice.js
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { PayloadAction } from '@reduxjs/toolkit';
import { startLoading, stopLoading } from '../loading/loadingSlice';
import { ISignInCredentials, ISignUpCredentials, signInApi, signUpApi } from './authApi';
import { AxiosError, AxiosResponse } from 'axios';
// import { IVerifyCredentials, verifyOtpApi } from './authApi';
import { errorAlert } from '../notifications/toasterNotificationSlice';

export interface IAdmin {
    _id: string,
    deviceID: string;
    devicePlatform: string;
    name: string,
    email: string,
}
export interface IUserWithAccessToken extends IAdmin {
    refreshToken: string,
    token: string
}
export interface IAuthState {
    adminDetails: IAdmin | undefined,
    accessToken: string | undefined,
    refreshToken: string | undefined,

}
const initialState: IAuthState = {
    adminDetails: undefined,
    accessToken: undefined,
    refreshToken: undefined
}

export const loginSlice = createSlice({
    name: 'auth',
    initialState: initialState,
    reducers: {
        signUp: (state, action: PayloadAction<IAdmin>) => {
            state.adminDetails = action.payload;
        },

        signIn: (state, action: PayloadAction<IUserWithAccessToken>) => {
            const { token, refreshToken, ...restData } = action.payload;
            state.adminDetails = restData;
            state.accessToken = token;
            state.refreshToken = refreshToken;
        },
        setRefreshTokens(state, action: PayloadAction<{ token: string; refreshToken: string }>) {
            state.accessToken = action.payload.token;
            state.refreshToken = action.payload.refreshToken;
        },
    },
});

export const adminSignUp = createAsyncThunk<AxiosResponse, ISignUpCredentials, { rejectValue: any }>(
    "/auth/admin/sign-up",
    async (ISignUpCredentials, thunkAPI) => {
        try {
            thunkAPI.dispatch(startLoading());
            const response: any = await signUpApi(ISignUpCredentials);

            if (response.status) {
                /**
                 * Success Login
                 */
                // console.log(response)
                thunkAPI.dispatch(signIn(response?.data))
                // console.log(response?.data)
                return response;
            } else {
                thunkAPI.dispatch(errorAlert(response.message))
                // console.log(response?.data)
                return thunkAPI.rejectWithValue(response);
            }
        } catch (error) {
            const err = error as AxiosError;
            console.log("first", err);
            thunkAPI.dispatch(errorAlert(err.message));
            console.log("second")
            return thunkAPI.rejectWithValue(err.message);
        }
        finally {
            thunkAPI.dispatch(stopLoading())
        }
    }
)

export const adminSignInSlice = createAsyncThunk<AxiosResponse, ISignInCredentials, { rejectValue: any }>(
    "admin/login",
    async (ISignInCredentials, thunkAPI) => {
        try {
            thunkAPI.dispatch(startLoading());
            const response: any = await signInApi(ISignInCredentials);
            if (response.status) {
                /**
                 * Success Login
                 */
                // console.log(response)
                thunkAPI.dispatch(signIn(response?.data))
                console.log(response?.data);
                return response;
            } else {
                thunkAPI.dispatch(errorAlert(response.message))
                // console.log("response ddd")
                return thunkAPI.rejectWithValue(response);
            }
        } catch (error) {
            const err = error as AxiosError;
            thunkAPI.dispatch(errorAlert(err.message));
            return thunkAPI.rejectWithValue(err.message);
        }
        finally {
            thunkAPI.dispatch(stopLoading())
        }
    }
)


export const { signIn, signUp, setRefreshTokens } = loginSlice.actions;
export default loginSlice.reducer;
